/**
 * Como um movimento de estoque se lê em português (F311). Saiu do histórico
 * do site (`stock-history-dialog.tsx`) quando o celular passou a mostrar o
 * mesmo histórico.
 */
export const MOVEMENT_KIND_LABELS = {
    entry: 'Entrada',
    exit: 'Saída',
    adjustment: 'Ajuste',
    transfer_out: 'Transferência (saída)',
    transfer_in: 'Transferência (entrada)',
};
export const MOVEMENT_SOURCE_LABELS = {
    manual: 'Manual',
    adjustment: 'Contagem',
    transfer: 'Transferência',
    // Os dois lados de uma venda: a saída quando ela conclui e a entrada que a
    // desfaz quando é cancelada. Um rótulo só, porque "mexeu por causa de uma
    // venda" é o fato; a direção já está no tipo ao lado.
    sale: 'Venda',
    // A entrada que um recebimento grava: o único movimento que carrega o que a
    // loja pagou de verdade.
    purchase: 'Compra',
    // Os dois lados de uma troca (F126): a peça que voltou e a que foi embora.
    exchange: 'Troca',
};
//# sourceMappingURL=inventory.js.map